import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { ControleSocietarioRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type ControleSocietarioProps = {
    controleSocietario: ControleSocietarioRow
}

export default function ControleSocietario({ controleSocietario }: ControleSocietarioProps) {
    return (
        <>
            <Divider textAlign="center">Controle Societário</Divider>
            {controleSocietario && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <GridItem label="Origem" value={controleSocietario.origem} xs={6} />
                    <GridItem label="Controle" value={controleSocietario.controle} xs={6} />
                    <GridItem label="Natureza" value={controleSocietario.natureza} xs={6} />
                    <GridItem
                        label="Data Atualização"
                        value={formatDate(controleSocietario.data_atualizacao, 'dd/MM/yyyy')}
                        xs={6}
                    />
                </Grid>
            )}
        </>
    )
}
